import Script from "next/script";

export default function DefaultSchema() {
  const schema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "Outshift | Cisco",
  image:
    "https://outshift.cisco.com/assets/shared/logos/preview-thumbnail-new.png",
  description:
    "Outshift - From emerging technologies to emerging customers, we are the incubation engine by Cisco",
  }

  return (
    <Script
      id="default-schema"
      type="application/ld+json"
      strategy="beforeInteractive"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(schema),
      }}
    />
  );
}
